import BrokenImageOutlined from '@mui/icons-material/BrokenImageOutlined';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

const PageBanner = ({
	error,
	imageUrl = undefined,
	title = undefined,
	subtitle = undefined,
}) =>
	!imageUrl || error ? (
		<Box
			sx={{
				textAlign: 'center',
				bgcolor: '#E0E0E0',
				py: { xs: 5, md: 10 },
				mt: { xs: 1, md: 2 },
			}}
			data-testid='page-banner-error'
		>
			<BrokenImageOutlined color='action' sx={{ fontSize: 40 }} />
		</Box>
	) : (
		<Card sx={{ mt: { xs: 1, md: 2 } }} data-testid='page-banner'>
			<Box sx={{ position: 'relative' }}>
				<CardMedia
					component='img'
					image={imageUrl}
					title={`${title} banner image`}
					sx={{
						height: { xs: 178, md: 237 },
					}}
				/>
				{/*
                The values in the bottom, left, and width properties
                are to change the position of the text overlay to be
                over the banner image.
            */}
				<Box
					sx={{
						position: 'absolute',
						bottom: { xs: '25%', sm: '25%', md: '30%' },
						left: { xs: '5%', sm: '5%', md: 61 },
						bgcolor: 'rgba(0, 0, 0, 0.54)',
						color: 'white',
						padding: '10px',
					}}
				>
					{title && (
						<Typography component='h2' variant='h4'>
							{title.toUpperCase()}
						</Typography>
					)}
					{subtitle && (
						<Typography component='h3' variant='h6'>
							{subtitle}
						</Typography>
					)}
				</Box>
			</Box>
		</Card>
	);

PageBanner.propTypes = {
	error: PropTypes.bool.isRequired,
	imageUrl: PropTypes.string,
	title: PropTypes.string,
	subtitle: PropTypes.string,
};

export default PageBanner;
